module.exports = __webpack_public_path__ + "img/icon390.91d5f58d.png";